import { createActions } from 'redux-actions';

export const {
  updateFilterFieldsOrdersForDocuments,
  searchOrdersForDocuments,
  changeTypeListDocuments,
  countFiltersOrdersForDocuments,
  resetFiltersOrdersForDocuments,
} = createActions(
  'UPDATE_FILTER_FIELDS_ORDERS_FOR_DOCUMENTS',
  'SEARCH_ORDERS_FOR_DOCUMENTS',
  'CHANGE_TYPE_LIST_DOCUMENTS',
  'COUNT_FILTERS_ORDERS_FOR_DOCUMENTS',
  'RESET_FILTERS_ORDERS_FOR_DOCUMENTS'
);
